import ProviderHeader from 'components/visit-creation/provider-info/ProviderHeader'
import TestIds from 'util/TestIds'
import AngleRightIcon from '@ui-components-3/icons/lib/regular/ArrowRight'
import { useTranslation } from 'react-i18next'
import { RadioCardsGroup } from '@ui-components-3/ui'
import { getPrintableShortProviderName } from 'util/provider'
import Provider from 'types/provider/provider'
import { MouseEventHandler } from 'react'

type ProviderCardsProps = {
  labelId: string
  data: Provider[]
  handleProviderSelection: (providerId: string) => void
  onDetailsClick: (provider: Provider) => MouseEventHandler<HTMLButtonElement>
  selectedProviderId: string
  indexOffset?: number
  isSuccess?: boolean
}

const ProviderCards = ({
  labelId,
  data,
  handleProviderSelection,
  onDetailsClick,
  selectedProviderId,
  indexOffset = 0,
  isSuccess = false,
}: ProviderCardsProps) => {
  const { t } = useTranslation()

  return (
    <RadioCardsGroup
      columnWidth={280}
      name="providerId"
      aria-labelledby={labelId}
      className="mt-xxs"
      options={data}
      controlPlacement="rt"
      onChange={(e) => handleProviderSelection(e.target.value)}
      value={selectedProviderId}
      getOptionValue={(provider) => provider.providerId}
      getLabelProps={(provider) => ({
        className:
          'bg-white flex flex-col justify-between [&>div]:h-full [&>div>input[type="radio"]]:self-center [&>div]:pb-0',
        suffix: (
          <button
            type="button"
            className="btn-small btn-neutral-borderless w-full justify-between rounded-none bg-neutral-200 text-neutral-600"
            onClick={onDetailsClick(provider)}
            aria-label={`See more details of ${getPrintableShortProviderName(provider, isSuccess)}`}
          >
            {t('providerSelection.seeMoreDetails')}
            <AngleRightIcon className="h-4 w-4" aria-hidden="true" />
          </button>
        ),
      })}
      getOptionLabel={(provider) => {
        const index = data.indexOf(provider) + indexOffset
        return (
          <ProviderHeader
            provider={provider}
            data-testid={TestIds.newVisit.input.provider(index)}
            infoTestId={TestIds.newVisit.label.providerInfo(index)}
            isSuccess={isSuccess}
            titleColor={'text-primary-600'}
          />
        )
      }}
    />
  )
}

export default ProviderCards
